import Vue from "vue";
import numeral from "numeral";

Vue.filter("pointFormat", (value: number) => numeral(value).format("0,0"));
